/**
 * Created by daniel on 23/04/17.
 */

import CellItem from './CellItem';
import RowItem from './RowItem';
import TableItem from './TableItem';
import RichText from "./RichText";
import ImageItem from "./ImageItem";
import TocItem from "./TocItem";
import MainRow from "./MainRow";
import Column from "./Column";

const TEMPLATE_COMPONENTS = {
  CELL_ITEM: {
    id: "CELL_ITEM",
    component: CellItem,
  },
  ROW_ITEM: {
    id: "ROW_ITEM",
    component: RowItem,
  },
  TABLE_ITEM: {
    id: "TABLE_ITEM",
    component: TableItem,
  },
  RICH_TEXT: {
    id: "RICH_TEXT",
    component: RichText,
  },
  IMAGE_ITEM: {
    id: "IMAGE_ITEM",
    component: ImageItem,
  },
  TOC_ITEM: {
    id: "TOC_ITEM",
    component: TocItem,
  },
  MAIN_ROW: {
    id: "MAIN_ROW",
    component: MainRow,
  },
  COLUMN: {
    id: "COLUMN",
    component: Column,
  }
};

export {
  TEMPLATE_COMPONENTS,
  CellItem,
  RowItem,
  TableItem,
  RichText,
  ImageItem,
  TocItem,
  MainRow,
  Column,
}


// WEBPACK FOOTER //
// ./src/App/Editor/components/primitives/index.js